import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { ArcticLabels } from "../../SpaErrors/components/arcticLabels.enums";
import {useSelector} from "react-redux";
import RootState from "../../../redux/states/root.state";
import { ErrorsIcon } from "../../../assets/svg/svg";

const CustomTooltip: React.FC<any> = ({ active, payload }) => {

  if (active && payload?.length) {
    return (
      <div className="rechart-tooltip">
        {payload.map((el:any, i:number) => (
          <div key={i}>
            <small>
              {el.name} : {`${el.value} spas`}
            </small>
            <br/>
          </div>
        ))}
      </div>
    );
  }
  return null;
};

// Ring geometry, shared with the CSS that sizes the centered count (see .kpi-chart-value strong).
const INNER_RADIUS_FRACTION = 0.78;
const INNER_RADIUS = `${INNER_RADIUS_FRACTION * 100}%`;

const SpaErrorsCard: React.FC = () => {
  const {spasWithErrors} = useSelector((state: RootState) => state.dashboard);
  const transformErrorCounts = (errorCounts: Record<string, number>) => {
    return Object.entries(errorCounts).map(([key, value]) => ({
      // resolve the label here so the tooltip payload always carries it
      name: ArcticLabels[key as keyof typeof ArcticLabels] || key,
      value
    }));
  };

  const errorData = spasWithErrors?.error_counts
      ? transformErrorCounts(spasWithErrors.error_counts)
      : [];

  const generateColor = (i:number,total: number) => {
    const hue = (i * 360) / total;
    return `hsl(${hue}, 70%, 50%)`; // Fixed saturation and lightness for consistency
  };

  const totalSpas = spasWithErrors?.spa_guids?.length ?? 0;

  return (
    <div className="kpi-card kpi-card--chart" id="errors">
      <div className="kpi-head">
        <span className="kpi-icon"><ErrorsIcon/></span>
        <span className="kpi-title">Spas with Errors</span>
      </div>

      <div className="kpi-chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Tooltip content={<CustomTooltip />} wrapperStyle={{zIndex: 1000}}/>
            {/* minAngle guarantees a hoverable sliver for rare codes -- without it a count of 1
                against thousands renders sub-pixel and the slice is effectively missing. The
                tooltip still reports the true count. paddingAngle stays small so those minimum
                slices aren't eaten by their own gaps. */}
            <Pie
                data={errorData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                innerRadius={INNER_RADIUS}
                outerRadius={"100%"}
                paddingAngle={1.5}
                minAngle={7}
                stroke="none"
            >

            {errorData.map((data:any, i)=>
                <Cell
                    key={`cell-${i}`}
                    name={data.name}
                    fill={generateColor(i, errorData.length)}
                />
            )}

            </Pie>
          </PieChart>
        </ResponsiveContainer>

        {/* Both vars feed the font-size calc in Home.css so the count always fits the ring's hole. */}
        <div
            className="kpi-chart-value"
            style={{
              "--kpi-digits": String(totalSpas).length,
              "--kpi-inner-radius": INNER_RADIUS_FRACTION,
            } as React.CSSProperties}
        >
          <strong>{totalSpas}</strong>
        </div>
      </div>
    </div>
);
};

export default SpaErrorsCard;
